import * as React from "react";
import { FunctionComponent, ChangeEvent, useState, useEffect } from "react";

export interface DebouncedTextInputProps {
    value: string;
    placeHolder: string;
    onImmediateChange: (value: string) => void;
    onDebouncedChange: (value: string) => void;
    debounceTime: number;
}

export const DebouncedTextInput: FunctionComponent<DebouncedTextInputProps> = props => {
    const [timerId, setTimerId] = useState(null);

    // Clear the timer when unmounted
    useEffect(() => clearTimer);

    function clearTimer() {
        if (timerId) {
            clearTimeout(timerId);
        }
    }

    function debounceChange(newValue: string) {
        clearTimer();
        setTimerId(setTimeout(() => props.onDebouncedChange(newValue), props.debounceTime));
    }

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        const newValue = e.target.value;
        props.onImmediateChange(newValue);
        debounceChange(newValue);
    }

    return (
        <input
            type="text"
            value={props.value}
            onChange={handleChange}
            placeholder={props.placeHolder}
        />
    );
};
